// extracted by mini-css-extract-plugin
export default {"zoomModal":"i4-z"};